import React from 'react';
import './index.css';
import ReactDOM from 'react-dom/client';
import './redesign/avaada-redesign.css';
import './redesign/meeting-details-redesign.css';
import './redesign/upcoming-meetings-polish.css';
import './redesign/recorded-meetings-polish.css';
import './redesign/all-meetings-polish.css';
import './redesign/dashboard-polish.css';
import './redesign/calendar-polish.css';
import './redesign/my-tasks-polish.css';
import './redesign/how-it-works-polish.css';
import './redesign/instant-join-polish.css';
import './redesign/create-meeting-polish.css';
import './redesign/recurring-invite-modal.css';
import './redesign/share-modal-polish.css';
import './redesign/login-polish.css';
import './redesign/ui-consistency.css';
import App from './App';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(<App />);
